import React from 'react';
import Select from 'react-select';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import classnames from 'classnames';

import moment from 'moment';
import DatePicker from 'react-datepicker';

// import DateTimePicker from 'component/DateTimePicker.js'

import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
import FormHelper from '../../form.js';

import toUTCtime from '../../../../helper/UTCtime.js';
import { toast } from 'react-toastify';

// Component
import ReminderRow from '../Row/ReminderRow.js';
import SelectQuery from '../../../../component/SelectQuery.js';

export default class ModalMaintenanceEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled            : false,
      toggledReminder    : false,
      overflow           : 'hidden',
      overflowReminder   : 'hidden',
      alias              : '', 
      service            : '',
      initService        : "",
      asset              : '',
      assetName          : "",
      assetAlias         : undefined,
      description        : '',
      status             : 'incomplete',  
      
      scheduledStart     : '',
      scheduledEnd       : '',
      nextScheduled      : '',
      
      scheduledStart_UTC : '',
      scheduledEnd_UTC   : '',
      nextScheduled_UTC  : null,
      
      repeatPeriod       : 0,
      repeatType         : 'days',
      isReminder         : '',
      isRepeating        : '',
      
      dataValid: false,

      // Date
      minDate             : moment(),
      minDateScheduledEnd : moment(),

      // Read Reminder
      isLoading  : 'success',
      count      : 0,
      dataArray  : [],
      rowElement : [],

      // Update Reminder
      time     : null,
      time_UTC : null,
      method   : 'email',
      email    : '',
      mobile   : '',
      isOpen   : false, 
    }
    this.IsPerAsset = props.hasOwnProperty('assetData');

    //Update
    this.onUpdateSuccess = this.onUpdateSuccess.bind(this);
    this.onUpdateFailed  = this.onUpdateFailed.bind(this);

    // calendar
    this.onChangeTime = this.onChangeTime.bind(this)

    this.onReadSuccess = this.onReadSuccess.bind(this)
    this.onReadFailed = this.onReadFailed.bind(this)

    this.reminderNotChange = null;

  }

  handleCheckboxChange(event) {
    if(event.target.name === 'isReminder') {
      this.setState({
        toggledReminder: event.target.checked,
        isReminder: event.target.checked ? 'Yes' : 'No',
      })
    } else {
      this.setState({
        toggled: event.target.checked,
        isRepeating: event.target.checked ? 'Yes' : 'No',
      })
    }
  }

  onOpen() {
    this.setState({overflow: 'visible'})
  }
  onClose() {
    this.setState({overflow: 'hidden'})
  }

  onOpenReminder() {
    this.setState({overflowReminder: 'visible'})
  }
  onCloseReminder() {
    this.setState({overflowReminder: 'hidden'})
  }

  clear() {
    this.setState({
      repeatPeriod         : 0,
      repeatType           : 'days',
      scheduledStart       : '',
      scheduledEnd         : '',
      nextScheduled        : '',
      scheduledStart_UTC   : '',
      scheduledEnd_UTC     : '',
      nextScheduled_UTC    : null,
      isReminder           : 'No',
      isRepeating          : 'No',
      minDate              : moment(),
      minDateScheduledEnd  : '',
    })
  }

  /* Positive number only */
  positiveNumber(e) {
    if (e.target.validity.valid) {
      this.setState({repeatPeriod: e.target.value})
    }
  }

  onChangeTime(date) {
    let tmpDate = new Date(date._d)
    
    this.setState({
      time     : date,
      time_UTC : toUTCtime(tmpDate)
    })
  }

  onUpdate(){
    if(!FormHelper.ValidateFormUpdate(this.state)) {
      return
    }
    Presenter.Update(RequestProperties.Update(this, this.onUpdateSuccess, this.onUpdateFailed))
  }

  onUpdateSuccess(params, response){
    toast.success('Maintenance has been successfully updated')
    this.props.loadData();
    this.props.closeModalEdit();
    this.props.offTmpRemainder();
    this.clear();
  }

  onUpdateFailed(response){
    console.log("Update Failed");
  }

  onChangeScheduledStart(date) {
    let tmpDate = new Date(date._d);
    let tmpEndDate = new Date(moment(date).add(1, 'days')._d);
    
    tmpDate.setHours(0);
    tmpDate.setMinutes(0);
    tmpDate.setSeconds(0);

    tmpEndDate.setHours(23);
    tmpEndDate.setMinutes(59);
    tmpEndDate.setSeconds(59);

    let endD = moment(date).add(1, 'days')
    let nextS = this.state.nextScheduled
    if (nextS){
      if (nextS < endD){
        nextS = moment(endD).add(1, 'days')
      }
    }

    this.setState({
      scheduledStart      : date,
      scheduledEnd        : moment(date).add(1, 'days'),
      minDateScheduledEnd : date,
      nextScheduled       : nextS,
      minDateNextSchedule : moment(date).add(2, 'days'),
      scheduledStart_UTC  : toUTCtime(tmpDate),
      scheduledEnd_UTC    : toUTCtime(tmpEndDate),
    })
  }

  onChangeScheduledEnd(date) {
    let tmpDate = new Date(date._d);
    tmpDate.setHours(23);
    tmpDate.setMinutes(59);
    tmpDate.setSeconds(59);

    let nextS = this.state.nextScheduled
    if (nextS){
      if (nextS <= date){
        nextS = moment(date).add(1, 'days')
      }
    }

    this.setState({
      scheduledEnd        : date,
      scheduledEnd_UTC    : toUTCtime(tmpDate),
      nextScheduled       : nextS,
      minDateNextSchedule : moment(date).add(1, 'days'),
    })
  }

  onChangeNextScheduled(date) {
    let tmpDate = new Date(date._d);
    
    tmpDate.setHours(0);
    tmpDate.setMinutes(0);
    tmpDate.setSeconds(0);

    this.setState({
      nextScheduled     : date,
      nextScheduled_UTC : toUTCtime(tmpDate),
    })
  }

  converToUTC(date, status) {
    let tmpDate = new Date(date._d);

    if(status === 'start') {
      tmpDate.setHours(0);
      tmpDate.setMinutes(0);
      tmpDate.setSeconds(0);
      return toUTCtime(tmpDate)
    } else {
      tmpDate.setHours(23);
      tmpDate.setMinutes(59);
      tmpDate.setSeconds(59);
      return toUTCtime(tmpDate)
    }

  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (
        <ReminderRow
          rowData           = {val} 
          key               = {index}
          index             = {index}
          action            = "edit"
          status            = {this.state.status}
          openModalReminder = {this.props.openModalReminderEdit}
        />
      )
    })
    return element;
  }


  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.RowData === "undefined" || nextProps.RowData === null) {
      this.setState({dataValid: false})
    } else {
      this.reminderNotChange = nextProps.RowData.IsReminder === 'Yes' ? true : false;

      if(nextProps.tmpRemainder) {
        // this.setState({toggledReminder    : true,})
      } else {        

        let nextScheduled = nextProps.RowData.NextScheduled;
        let nextScheduled_UTC = null;
        if(nextScheduled !== null ) {
          nextScheduled = moment(nextProps.RowData.NextScheduled)
          nextScheduled_UTC = this.converToUTC(moment(nextProps.RowData.NextScheduled), 'end')
        } else {
          nextScheduled = null
          nextScheduled_UTC = null
        }

        this.setState({
          dataValid          : true,
          alias              : nextProps.RowData.Alias,
          service            : nextProps.RowData.Service.Alias,
          initService        : {
            Alias: nextProps.RowData.Service.Alias,
            Name: nextProps.RowData.Service.Name,
          },
          asset              : nextProps.RowData.Asset.Alias,
          assetAlias         : nextProps.RowData.Asset.Alias,
          assetName          : nextProps.RowData.Asset.Name,
          description        : nextProps.RowData.Description,
          status             : nextProps.RowData.Status,

          scheduledStart     : moment(nextProps.RowData.ScheduledStart),
          scheduledEnd       : moment(nextProps.RowData.ScheduledEnd),
          nextScheduled      : nextScheduled,
          
          scheduledStart_UTC : this.converToUTC(moment(nextProps.RowData.ScheduledStart), 'start'),
          scheduledEnd_UTC   : this.converToUTC(moment(nextProps.RowData.ScheduledEnd), 'end'),
          nextScheduled_UTC  : nextScheduled_UTC,
 
          minDateScheduledEnd : moment(nextProps.RowData.ScheduledStart),

          repeatPeriod       : nextProps.RowData.RepeatPeriod,
          repeatType         : nextProps.RowData.RepeatType,
          isReminder         : nextProps.RowData.IsReminder,
          toggledReminder    : nextProps.RowData.IsReminder === 'Yes' ? true : false,
          isRepeating        : nextProps.RowData.IsRepeating,
          toggled            : nextProps.RowData.IsRepeating === 'Yes' ? true : false,
        })

      }

      /**
      |--------------------------------------------------
      | this onReadWork is use for load data isReminder list.
      | if you want to remove this. please change logic when added list reminder.
      |--------------------------------------------------
      */
      this.onReadWork(nextProps.RowData.Alias);

    }
  }

  // Read reminder
  onReadWork(work) {
    Presenter.ReadReminderByWork(
      RequestProperties.ReadReminderByWork('Read', work, this, this.onReadSuccess, this.onReadFailed)
    )
  }

  onReadSuccess(params, response){
    this.setState({
      isLoading  : 'success',
      count      : response.data.count,
      dataArray  : response.data.results,
      rowElement : this.generateRow(response.data.results)
    })
  }

  onReadFailed(response){
    this.setState({
      isLoading: 'failed',
    });
  } 

  confirmClose() {
    if(this.state.toggledReminder !== this.reminderNotChange) {
      let cm = window.confirm('data has not been saved and will be lost, click ok to save the data');
      if(cm) {
        this.onUpdate();
      }else {
        this.props.closeModalEdit()
      }
    } else {
      this.props.closeModalEdit()
    }
  }

  renderAssetField(status){
    if(this.IsPerAsset){
      return(
        <input
          type="text" 
          className="form-control" 
          value={this.props.assetData.Name}
          disabled
        />
      )
    }else{
      return(
        <input type="text"
          className="form-control"
          value={this.state.assetName}
          disabled
        />
      )
    }
  }

  willMount(){
    this.setState({
      asset : this.IsPerAsset ? this.props.assetData.Alias : '',
    })
  }

  render() {
    const props = this.props;
    const {status} = this.state;

    if(!this.state.dataValid) {
      return(null)
    }

    return (
      <Modal isOpen={props.modalEdit} onEnter = {() => this.willMount()} toggle={()=>this.confirmClose()}  className='modal-lg' backdrop="static">
        <ModalHeader toggle={()=>this.confirmClose()}>Edit Maintenance</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-6">
              <label className="required">Asset / Tools</label>
              {this.renderAssetField(status)}
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Maintenance</label>
              <SelectQuery 
                placeholder="Type Maintenance"
                value={this.state.service}
                onChange={(e) => this.setState({service: e.value})}
                urlKey="read-maintenance-type-autocomplete"
                valKey="Alias"
                valLabel="Name"
                initOption={this.state.initService}
                isCreatable={false}
                UserReducer={this.props.UserReducer}
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Schedule Start</label>
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                minDate ={this.state.minDate}
                selected={this.state.scheduledStart}
                onChange={(e)=> this.onChangeScheduledStart(e) }
                readOnly
                disabled={status === 'in-progress'}
              />
              {/* <DateTimePicker
                minDate ={this.state.minDate}
                selected={this.state.scheduledStart}
                onChange={(e)=> this.onChangeScheduledStart(e) }
              /> */}
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Schedule End</label>
              {/* <DateTimePicker
                minDate ={this.state.minDateScheduledEnd}
                selected={this.state.scheduledEnd}
                onChange={(e)=> this.onChangeScheduledEnd(e)}
              /> */}
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                minDate ={this.state.minDateScheduledEnd}
                selected={this.state.scheduledEnd}
                onChange={(e)=> this.onChangeScheduledEnd(e)}
                readOnly
              />
            </div>
            <div className="form-group col-md-12">
              <label className="optional">Next Schedule </label>
              <span 
                className="clear-date no-select" 
                onClick={()=>{this.setState({nextScheduled: '', nextScheduled_UTC: null})}}>clear</span>
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                minDate ={moment(this.state.scheduledEnd).add(1, 'days')}
                selected={this.state.nextScheduled}
                onChange={(e)=> this.onChangeNextScheduled(e)}
                disabled={status === 'in-progress'}
              />
              {/* <DateTimePicker
                minDate ={moment(this.state.scheduledEnd).add(1, 'days')}
                selected={this.state.nextScheduled}
                onChange={(e)=> this.onChangeNextScheduled(e)}
                disabled={status === 'in-progress'}
              /> */}
            </div>
            <div className="form-group col-sm-12">
              <label className="required">Description</label>
              <textarea 
                className="form-control" 
                cols="30" 
                rows="3"
                value={this.state.description}
                onChange={(e)=>this.setState({description: e.target.value})} 
                disabled={status === 'in-progress'}
              />
            </div>

            {/* Repeat */}
            <div className="isRepeatLabel">           
              <label className="spaceRRR mb0">Repeat</label>
              <label className="switch switch-sm switch-text switch-primary mb0">
                <input 
                  onChange={(event)=>this.handleCheckboxChange(event)} 
                  name='isRepeat'
                  type="checkbox" 
                  className="switch-input"
                  checked={this.state.toggled}
                  disabled={status === 'in-progress'}
                />
                <span className="switch-label" data-on="On" data-off="Off"></span>
                <span className="switch-handle"></span>
              </label>
            </div>
            <div className={classnames('isRepeatBox', {open: this.state.toggled})} style={{'overflow': this.state.overflow}}>
              <div className="row">
                <div className="form-group col-sm-6" style={{'paddingTop': '13px'}}>
                  <label className="required">Repeat Period</label>
                  <input type="number"
                    className="form-control"
                    onChange={(e)=>this.positiveNumber(e)}
                    min="0"
                    max="999"
                    pattern="^[0-9]"
                    name="repeartPeriod"
                    value={this.state.repeatPeriod}
                    disabled={status === 'in-progress'}
                  />
                </div>
                <div className="form-group col-sm-6" style={{'paddingTop': '13px'}}>
                  <label>Repeat Type&nbsp;<small>(default : Days)</small></label>
                  <Select
                    name="service "
                    placeholder="Type Repeat Type"
                    onOpen={()=>this.onOpen()}
                    onClose={()=>this.onClose()}
                    clearable={false}
                    value={this.state.repeatType}
                    options={[
                      { value: 'days', label: 'Days' },
                      { value: 'weeks', label: 'Weeks' },
                      { value: 'months', label: 'Months' },
                      { value: 'years', label: 'Years' },
                    ]}
                    onChange={(val) => this.setState({repeatType: val.value})}
                    disabled={status === 'in-progress'}
                  />
                </div>
              </div>
            </div>

            {/* Reminder */}
            <div className="isRepeatLabel">     
              <label className="spaceRRR mb0">Use Reminder</label>
              <label className="switch switch-sm switch-text switch-primary mb0">
                <input 
                  onChange={(event)=>this.handleCheckboxChange(event)}
                  name='isReminder'
                  type="checkbox" 
                  className="switch-input" 
                  checked={this.state.toggledReminder}
                  disabled={status === 'in-progress'}
                />
                <span className="switch-label" data-on="Yes" data-off="No"></span>
                <span className="switch-handle"></span>
              </label>
            </div>
            <div className={classnames('isRepeatBox', {open: this.state.toggledReminder})} style={{'overflowY': 'scroll'}}>
              <div className="row">
                <div className="col-sm-12 list-separator" style={{'paddingTop': '13px'}}>
                  <div className="item-inner">Reminder List 
                    <button 
                      className="btn btn-link" 
                      onClick={()=>{this.props.openModalReminderAdd(this.state.alias)}}><i className="icon-plus"></i>&nbsp;add reminder</button>
                  </div>
                </div>
                <table className="table table-striped table-responsive m-top-15 table">
                  <thead>
                    <tr>
                      <th>Method</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Time</th>
                      {this.state.status !== 'in-progress' &&
                        <th className="text-center">Action</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.rowElement}
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={()=>this.confirmClose()}>Cancel</Button>
          <Button color="primary" onClick={()=>this.onUpdate()}>Update</Button>
        </ModalFooter>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/Modal/ModalMaintenanceEdit.js